// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recipe-products__list .swiper-container{margin:0 -16px;padding:4px 16px 24px}@media only screen and (min-width:992px){.recipe-products__list .swiper-container{margin:-12px -16px 0;padding:12px 16px 24px}}.recipe-products__list .c-slider__bottom-wrapper{margin-top:0}.recipe-products__list .c-slider__arrow{display:none}@media only screen and (min-width:992px){.recipe-products__list .c-slider__arrow{display:flex}}", ""]);
// Exports
module.exports = exports;
